import moment from "moment";
import "moment-timezone";

const dateService = ($window, $timeout, storeService, propertyService) => {
  let propertyTimezone = undefined;

  const checkMaxDate = (momentDate, isStartDate = false) => {
    if (!moment.isMoment(momentDate)) {
      momentDate = convertToMoment(momentDate);
    }

    if (momentDate.diff(moment(), "days") > 357) {
      momentDate = moment()
        .add(1, "years");

      if (isStartDate) {
        momentDate.subtract(6, "days");
      }
    }

    return momentDate;
  };

  const verifyDateGteToday = momentDate => {
    const minDate = getMinDate();
    if (momentDate && momentDate.isSameOrAfter(minDate, "day")) {
      return momentDate;
    }

    return minDate;
  };

  const checkStoredDate = (setDates = true, returnAsMoment = false, incomingDate = undefined) => {
    const timezone = getTimezone();

    let momentDate;
    let searchDate = storeService.get("searchDate");

    if (searchDate || (!searchDate && incomingDate)) {
      if (!incomingDate) {
        momentDate = buildMomentDate(searchDate);
      } else {
        momentDate = incomingDate;
      }

      if (momentDate.isBefore(moment(), "day")) {
        storeService.remove("searchDate");
      }
    }

    if (!momentDate || !momentDate.isValid()) {
      momentDate = moment();
    }
    momentDate = withinRestrictedDates(momentDate);
    momentDate = verifyDateGteToday(momentDate);
    momentDate = momentDate.tz(timezone);

    if (setDates) {
      storeService.set("searchDate", momentDate.format("YYYY-MM-DD"));
    }

    if (returnAsMoment) {
      return momentDate;
    }

    return momentDate.format("YYYY-MM-DD");
  };

  const convertToMoment = (date) => {
    const timezone = getTimezone();

    return moment(date)
      .tz(timezone);
  };

  const checkDate = (date, returnAsMoment = false) => {
    if (!moment.isMoment(date)) {
      date = convertToMoment(date);
    }

    return checkStoredDate(true, returnAsMoment, date);
  };

  const getTimezone = () => {
    if (!propertyTimezone) {
      propertyTimezone = propertyService.get("timezone");
    }

    return propertyTimezone;
  };

  const displayFromToDate = (fromDate, toDate) => {
    if (!fromDate || !toDate) {
      return false;
    }

    let startDate = buildMomentDate(fromDate);
    let endDate = buildMomentDate(toDate);

    if (startDate.isSame(endDate, "day")) {
      return `on ${startDate.format("Do MMMM YYYY")}`;
    }

    if (startDate.isSame(endDate, "month")) {
      return `from ${startDate.format("Do")} to ${endDate.format("Do MMMM YYYY")}`;
    }

    if (startDate.isSame(endDate, "year")) {
      return `from ${startDate.format("Do MMMM")} to ${endDate.format("Do MMMM YYYY")}`;
    }

    return `from ${startDate.format("Do MMMM YYYY")} to ${endDate.format("Do MMMM YYYY")}`;
  };

  const buildMomentDate = date => {
    if (date.length === 10) {
      date += " 00:00:00";
    }

    return moment(`${date.replace("T", " ")}+00:00`);
  };

  const getMinDate = () => {
    let minDate = moment();

    const closeDays = propertyService.get("stopDays");
    const minSearchDays = propertyService.get("minSearchDays");
    const closeTime = propertyService.get("stopTime");

    if (closeDays
      && (!minSearchDays || closeDays > minSearchDays)) {
      const date = minDate.add(closeDays, "day");
      setCalendarParameter('minDate', date);
      return date;
    }

    if (minSearchDays) {
      return minDate.add(minSearchDays, "days");
    }

    if (closeTime
      && minDate.diff(moment(closeTime, "HH:mm:ss")) > 0) {
      const date = minDate.add(1, "day");
      setCalendarParameter('minDate', date);
      return date;
    }

    return minDate;
  };

  const setCalendarParameter = (param, value) => {
    $timeout(() => {
      if (
        $window.fpInput
        && typeof $window.fpInput === "object"
        && typeof $window.fpInput.set === "function"
      ) {
        if(value && moment()
          .isValid(value)) {
          value = value.format('YYYY-MM-DD');
        }
        $window.fpInput.set(param, value);
      }
    }, 1000);
  };

  const withinRestrictedDates = date => {
    if (date && moment()
      .isValid(date)) {
      let startEditBooking = storeService.get("start_date");
      let endEditBooking = storeService.get("end_date");
      const maxSearchDays = propertyService.get('maxActivitySearchDays');

      if (startEditBooking && endEditBooking) {
        startEditBooking = moment(startEditBooking);
        endEditBooking = moment(endEditBooking);

        if (date.diff(startEditBooking, "days") < 0
          || date.diff(endEditBooking, "days") > 0) {
          date = startEditBooking;
          return date;
        }
      }

      if ($window.location.pathname.includes('/classes')
        && maxSearchDays && maxSearchDays > 0) {
        if (date
          .diff(moment()
            .add(maxSearchDays, 'days'), 'hours') > 0) {
          date = moment();
        }
      }
    }

    return date;
  };

  return {
    checkMaxDate,
    verifyDateGteToday,
    checkStoredDate,
    convertToMoment,
    checkDate,
    displayFromToDate,
    setCalendarParameter
  };
};


dateService.$inject = [ "$window", "$timeout", "storeService", "propertyService" ];

export default dateService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/services/date.service.js